export default __webpack_public_path__ + "static/media/serenityyetmis1.f41c4ba2.jpg";